// extracted by mini-css-extract-plugin
module.exports = {"modeSwitch":"mode-switch_modeSwitch__5bA27"};